import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useSessionStore } from '@/stores/SessionStore'
import { useCachedFetch } from '@/composables/useFetch'
import featuredProviderData from '@/data/featuredProviders.json'

import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $BASEURL } = useConfigurationGlobals()

export const useProviderStore = defineStore('providerStore', () => {
  const sessionStore = useSessionStore();

  const featuredProviders = featuredProviderData.providers;

  const allProviders = ref(null);
  const mesonets = ref(null);

  const otherProviders = computed(() => {
    if (!allProviders.value || allProviders.value.length === 0 || !featuredProviders) {
      return [];
    }

    return allProviders.value.filter(provider => {
      for (let featuredProvider of featuredProviders) {
        if (featuredProvider.provider_id.indexOf(provider.provider_id) > -1) return false;
      }

      return true;
    });
  });

  const otherProviderIds = computed(() => otherProviders.value.map(provider => provider.provider_id));

  const combinedProviders = computed(() => {
    const featuredProvidersCopy = [...featuredProviders];

    featuredProvidersCopy.push({
      name: 'All Others',
      id: featuredProviders.length + 1,
      provider_id: otherProviderIds.value
    })

    return featuredProvidersCopy;
  });

  async function getMesonets(settings = {}, overrideCache = false) {
  
    settings.stormprint_only = true;

    const data = await getProviders(settings, overrideCache)

    if (data.error) {
      return data;
    }

    if (!data.providers || data.providers.length === 0) {
      console.warn('No mesonets found');

      mesonets.value = [];

      return { error: true, message: 'No mesonets found' };
    }

    mesonets.value = data.providers;

    return data.providers;
  }

  async function getAllProviders(settings = {}, overrideCache = false) {
  
    settings.stormprint_only = false;

    const data = await getProviders(settings, overrideCache)

    if (data.error) {
      return data;
    }

    if (!data.all_providers || data.all_providers.length === 0) {
      console.warn('No providers found');

      allProviders.value = [];

      return { error: true, message: 'No providers found' }
    }    

    allProviders.value = data.all_providers;

    return data.all_providers;
  }

  async function getProviders(settings = {}, overrideCache = false) {
    const defaultSettings = {
      stormprint_only: false,
      wf_token: sessionStore.token
    }

    const params = Object.assign(defaultSettings, settings)
    const queryString = new URLSearchParams(params).toString()
    const url = `${$BASEURL}/spot/getProviders?${queryString}`

    try {
      const { error, data } = await useCachedFetch(url, {}, true, overrideCache)

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }

      return data.value
    } catch (error) {
      console.warn(error)

      return { error: true, message: error }
    }
  }

  return {
    allProviders,
    mesonets,
    featuredProviders,
    otherProviders,
    otherProviderIds,
    combinedProviders,
    getMesonets,
    getAllProviders
  }
})
